/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react/macro";
import { useEffect, useState } from "react";

import { Outlet } from "react-router-dom";

import BaseHeader from "./BaseHeader";
import SideMenu from "./SideMenu";
import BaseFooter from "./BaseFooter";

import "styles/index.css";

const Layout = () => {
  const [showSideNav, setShowSideNav] = useState(false);
  const [showCityInfo, setShowCityInfo] = useState(false);

  useEffect(() => {
    if (showSideNav || showCityInfo) {
      document.body.style.overflow = "hidden";
      return;
    }

    document.body.style.overflow = "unset";
  }, [showSideNav, showCityInfo]);

  return (
    <>
      <BaseHeader
        showSideNav={showSideNav}
        setShowSideNav={setShowSideNav}
        showCityInfo={showCityInfo}
        setShowCityInfo={setShowCityInfo}
      />

      <div
        className="min-w-[375px]"
        css={css`
          background-image: linear-gradient(
            55.33deg,
            #efefef 28.53%,
            #ffffff 86.48%
          );
          background-attachment: fixed;
        `}
      >
        <div className="md:flex">
          <SideMenu showSideNav={showSideNav} setShowSideNav={setShowSideNav} />
          <div className="w-full px-4 pt-4 pb-16 md:px-10 md:pt-8 lg:px-16 lg:pt-8">
            <div className="-mb-4 min-h-[calc(100vh-66px)] bg-opacity-10 bg-[url(../images/icon-bar-chart-mobile.svg)] bg-[right_bottom_-50px] bg-no-repeat pb-[124px] md:bg-[url(../images/icon-bar-chart.svg)] md:bg-[length:80%_auto] md:bg-[right_bottom_-190px]  lg:bg-auto">
              <Outlet />
            </div>
            <BaseFooter />
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;
